<template>
  <div id="app">
    <header-nav></header-nav>
    <!-- 占位符 -->
    <div style="width:100%;height:100px"></div>
    <affix></affix>
    <router-view/>
    <footer-com></footer-com>
  </div>
</template>

<script>
import headerNav from './components/headerNav.vue'
import affix from './components/affix.vue'
import footerCom from './components/footerCom.vue'
export default {
  components:{
    headerNav,
    footerCom,
    affix
  },
  name: 'App'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue